"use client";
import { Button } from "@/components/ui/Button";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="relative flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-1">
          <h2 className="text-lg font-medium text-foreground">
            Page not found
          </h2>
          <p className="text-sm text-comp-text-tertiary">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="flex flex-row gap-2">
          <Button variant="solid" onClick={() => router.back()}>
            Go back
          </Button>
          <Button asChild variant="outline">
            <Link href="/">Go to home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
